<template>
  <v-content>
    <v-container fluid align="start">
      <v-row align="start">
        <v-col>
          <router-view />
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
export default {
  name: "defaultLayout"
};
</script>

<style scoped></style>
